// extracted by mini-css-extract-plugin
export default {"container":"SimpleInterest_container__CtOwz","breadCrumb":"SimpleInterest_breadCrumb__U4GVN"};